import createRequest from 'modules/api/request';
import handleRequest from 'modules/api/common';
import { HTTP_METHODS, URLS } from 'modules/api/constants';
import { CancelFunctions } from 'components/common/types';
import type {
  EmailNotificationConfigDTO,
  EnableEmailNotificationBody,
} from 'components/common/types/EmailNotification.types';
import { LookupWindow } from 'components/common/types/EmailNotification.types';

export type { EmailNotificationConfigDTO, EnableEmailNotificationBody };
export { LookupWindow };

export const getEmailNotificationConfig = async (
  publisher: string,
  cancelFunctions: CancelFunctions,
): Promise<EmailNotificationConfigDTO | undefined> => {
  const reqOptions = {
    url: URLS().FETCH_EMAIL_NOTIFICATION_CONFIG(publisher),
    method: HTTP_METHODS.GET,
    ignoreNotifyError: true,
  };

  const { send, cancel } = createRequest(reqOptions);

  if (cancelFunctions.FETCH_EMAIL_NOTIFICATION_CONFIG) cancelFunctions.FETCH_EMAIL_NOTIFICATION_CONFIG();
  cancelFunctions.FETCH_EMAIL_NOTIFICATION_CONFIG = cancel;

  try {
    const result = await send();
    return result?.data;
  } catch (error: unknown) {
    const axiosError = error as { response?: { status?: number } };
    if (axiosError?.response?.status === 404) {
      return undefined;
    }
    throw error;
  }
};

export const enableEmailNotification = async (
  body: EnableEmailNotificationBody,
  cancelFunctions: CancelFunctions,
): Promise<EmailNotificationConfigDTO> => {
  const reqOptions = {
    url: URLS().ENABLE_EMAIL_NOTIFICATION(),
    method: HTTP_METHODS.POST,
    data: body,
    ignoreNotifyError: true,
  };

  return handleRequest<EmailNotificationConfigDTO>(reqOptions, cancelFunctions, 'ENABLE_EMAIL_NOTIFICATION');
};

export const disableEmailNotification = async (
  publisher: string,
  cancelFunctions: CancelFunctions,
): Promise<EmailNotificationConfigDTO> => {
  const reqOptions = {
    url: URLS().DISABLE_EMAIL_NOTIFICATION(publisher),
    method: HTTP_METHODS.POST,
    ignoreNotifyError: true,
  };

  return handleRequest<EmailNotificationConfigDTO>(reqOptions, cancelFunctions, 'DISABLE_EMAIL_NOTIFICATION');
};
